(function () {
    'use strict';

    function addAnimationToButton(button) {
        // 移除现有的背景样式，用渐变来实现动画
        button.style.setProperty('background', 'linear-gradient(to bottom, #7B5BA7 50%, #f9c03b 50%)', 'important');
        button.style.setProperty('background-size', '100% 200%', 'important');
        button.style.setProperty('background-position', '0% 0%', 'important');
        button.style.setProperty('transition', 'none', 'important');

        // 延迟添加过渡效果，避免页面加载时的动画
        setTimeout(() => {
            button.style.setProperty('transition', 'background-position 0.3s ease', 'important');
        }, 100);

        // 悬停事件
        button.addEventListener('mouseenter', function () {
            button.style.setProperty('background-position', '0% 100%', 'important');
        });

        button.addEventListener('mouseleave', function () {
            button.style.setProperty('background-position', '0% 0%', 'important');
        });
    }

    function initAddToCartAnimation() {
        // 查找所有Add to Cart按钮
        const selectors = [
            'form[action*="/cart/add"] button[type="submit"]',
            '.product-form button[name="add"]',
            '.btn.add-to-cart',
            '.btn--large.add-to-cart',
            'button.add-to-cart',
            'button[name="add"]'
        ];

        selectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);

            buttons.forEach(button => {
                // 检查是否已经添加过动画
                if (!button.hasAttribute('data-animation-added')) {
                    addAnimationToButton(button);
                    button.setAttribute('data-animation-added', 'true');
                }
            });
        });
    }

    // 初始化
    function init() {
        initAddToCartAnimation();

        // 监听动态内容变化
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    initAddToCartAnimation();
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // 启动
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // 确保在页面完全加载后也运行
    window.addEventListener('load', function () {
        setTimeout(init, 500);
    });

})();